import React from 'react';
import { Navigate } from 'react-router-dom';

const Protected = ({ children }) => {
  const email = localStorage.getItem('userEmail');
  if (email !== process.env.REACT_APP_ADMIN_KEY) {
    // Redirect unauthorized users to home or login page
    return <Navigate to="/" replace />;
  }

  return children;
};

export default Protected;
